<template>
    <nav aria-label="breadcrumb" class="d-none d-xl-block">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#">Настройка доступа</a></li>
            <li class="breadcrumb-item active" aria-current="page">Редактировать настройки пользователя</li>
        </ol>
    </nav>
    <div class="title-block">
        <div class="title-block__title">
            Редактировать настройки пользователя
        </div>
    </div>
    <div class="access-edit-user-settings">
        <div class="access-edit-user-settings__title">
            Евгений Евгеньев
        </div>
        <form class="access-edit-user-settings-form">
            <div class="mb-3">
                <label for="email" class="form-label">Почта</label>
                <input type="email" class="form-control edit" name="email" id="email" value="mail@mail.ru" placeholder="Почта">
            </div>
            <div class="mb-3">
                <label for="password" class="form-label">Пароль</label>
                <input type="password" class="form-control edit" name="password" id="password" value="12345678abc" placeholder="Пароль">
            </div>
            <div class="mb-3">
                <label for="passwordConfirm" class="form-label">Подтвердите пароль</label>
                <input type="passwordConfirm" class="form-control edit" name="passwordConfirm" id="passwordConfirm" value="12345678abc" placeholder="Подтвердите пароль">
            </div>
            <div class="mb-4">
                <div class="form-label">Администратор</div>
                <v-select
                    v-model="role"
                    :items="['Администратор', 'Программист', 'Менеджер DS', 'Менеджер клиента']"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>
            <button type="button" class="btn btn-primary w-100">
                Сохранить изменения
            </button>
        </form>
    </div>
</template>

<script>
export default {
    name: "AccessEditUserSettings",
    data: () => {
        return {
            role: 'Администратор'
        };
    },
};
</script>
